import React from 'react';
import PropTypes from 'prop-types';

import { convertToLocaleDateTime } from '../../utils/components';

/**
 * @param {{ history?: any[], translations?: any, className?: string }} props
 */
const OrderPaymentHistory = (props) =>
{
    const { history, translations, className } = props;

    if (!history || history.length === 0) {
        return (
            <fieldset className="col-12">
                <label>{translations?.caption || 'Historia płatności'}</label>
                <div>{translations?.empty || 'Brak historii płatności.'}</div>
            </fieldset>
        );
    }

    return (
        <fieldset className="col-12">
            <label>{translations?.caption || 'Historia płatności'}</label>

            <table className={className}>
                <thead>
                    <tr>
                        <th>{translations?.changeDate || 'Data zmiany'}</th>
                        <th>{translations?.provider || 'Dostawca'}</th>
                        <th>{translations?.providerTransactionId || 'ID transakcji dostawcy'}</th>
                        <th>{translations?.eventType || 'Typ zdarzenia'}</th>
                        <th>{translations?.rawStatus || 'Status z bramki'}</th>
                        <th>{translations?.previousStatus || 'Poprzedni status płatności'}</th>
                        <th>{translations?.newStatus || 'Nowy status płatności'}</th>
                        <th>{translations?.statusChanged || 'Status zmieniony'}</th>
                        <th>{translations?.message || 'Komunikat'}</th>
                    </tr>
                </thead>
                <tbody>
                    {history.map(item => (
                        <tr key={item.id}>
                            <td>{convertToLocaleDateTime(item.created)}</td>
                            <td>{item.provider || '-'}</td>
                            <td>{item.providerTransactionId ?? '-'}</td>
                            <td>{item.eventType || '-'}</td>
                            <td>{item.rawStatus || '-'}</td>
                            <td>{item.previousPaymentStatus ?? '-'}</td>
                            <td><strong>{item.paymentStatus ?? '-'}</strong></td>
                            <td>{item.statusChanged ? 'Tak' : 'Nie'}</td>
                            <td>{item.message || '-'}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </fieldset>
    );
};

OrderPaymentHistory.propTypes =
{
    history: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        orderId: PropTypes.number,
        created: PropTypes.string,
        provider: PropTypes.string,
        providerTransactionId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        eventType: PropTypes.string,
        rawStatus: PropTypes.string,
        previousPaymentStatus: PropTypes.number,
        paymentStatus: PropTypes.number,
        statusChanged: PropTypes.bool,
        message: PropTypes.string,
    })),
    className: PropTypes.string,
    translations: PropTypes.object,
};

export default OrderPaymentHistory;